module.exports = __webpack_public_path__ + "img/galery-inge-v6-1-zoom.9a335ef7.jpg";